module.exports = __webpack_public_path__ + "img/isec.09fe9065.webp";